import { Table, Database } from './lib/Database';

export default Database;
export { Table, Database };